import { IResponseBase, IPagedResultset, ResponseBase } from "./app";
import { ICustomer } from './customers';

export interface IInvoice {
  EmailRecipients: string[];
  Invoice: IInvoiceData;
	MessageForCustomer: string;
}


export interface IPaymentData{

  CustomerSignature: string;

	PayByCheck: boolean;
  PayByCreditCard: boolean;
  PayByCash: boolean;
  PayByPurchaseOrder: boolean;
	
	PayByCheckNum: string;
  PayByPONum: string;
  PayByCreditCardLast4: string;
  PayByCreditCardName?: string;

  PayByCashAmount: number;
	PayByCheckAmount: number;
  PayByPOAmount: number;
  PayByCreditCardAmount: number;

	PayByAuth : boolean;
	PayByAuthNumber: string;
	PayByAuthAmount: number;
  

  Tax?: boolean;

	PaymentNotes: string;
	
	InvoiceSubTotal: number;
	InvoicePayments: number;
	InvoiceTax: number;
	InvoiceTotal: number;

}


export interface IInvoiceData {
  InvoiceNumber?: string;
  WorkOrderID?: number;
  CustomerID?: number;
  CustomerName?: string;
	CustomerEmail?: string;
  CreatedOn?: string;
  JobNotes?: string;
	IsDraft?: boolean;
	
  IsVoided?: boolean;
	IsPosted?: boolean;

	TechID?: number;
	CarJobs?: ICarJob[];
	PaymentData: IPaymentData;

	Status?: InvoiceStatus;

	LastTimeMailed?: Date;
}

export interface ILineItem {
  Value?: number;
  Name?: string;
  ItemID?: number;
  ItemName?: string;
  ItemQty?: number;
  ItemPrice?: number;
  ItemTotal?: number;
  Index?: number;
}

export interface ICarJob {
  Year: string;
  Make: string;
  Model: string;
	Last8Vin: string;
	StockNum: string;
	Color: string;
	Mileage: string;
  JobDetails: IJobDetail[];
	SubType: SUB_TYPE;
}


export enum SUB_TYPE{
	Vehicle = 0,
	LooseWheel = 10,
}


export enum JOB_TYPES {
	Cosmetic= 0,
	Bent= 10,
	MaterialCharge = 20,
	Other = 30,
}

// = [
//   {
//     value: 0,
//     text: "Cosmetic Rim Repair",
//   },
//   {
//     value: 10,
//     text: "Bent",
//   },
//   {
//     value: 0,
//     text: "Material Charge",
//   },
//   // {
//   //   value: 20,
//   //   text: "Material Fee",
//   // },
// ];

export interface IJobDetail {
  JobType: number;
  WheelFR: boolean;
  WheelFL: boolean;
  WheelBR: boolean;
	WheelBL: boolean;
	PricePerWheel: number;
  JobPrice: number;
	ServiceItemID: number;
	ServiceItemName: string;
	LooseWheelCount: number;
	ServiceQty: number;
}

// Search Invoices
export interface ISearchInvoicesData extends IPagedResultset {
  Invoices: IInvoiceData[];
}

export class ISearchInvoicesRequest {
  public Keyword: string = '';
  public Page?: number;
	public PageSize?: number;
	
	public InvoiceStatus: InvoiceStatus[] = [InvoiceStatus.Any];

	public MinDate?: Date;
	public MaxDate?: Date;

	public TechID?: number;
	public CustomerID?: number;

	public PaidOnly: boolean = false;
	public OrderBy: string;
}

export interface ISearchInvoicesResponse extends IResponseBase {
  Results: ISearchInvoicesData;
}

// Begin invoice
export interface IInvoiceBeginResponse extends IResponseBase {
  InvoiceNumber: string;
  ItemLines: ILineItem[];
}

// Invoices Save Draft
export interface IInvoiceSaveDraftRequest {
	Invoice: IInvoiceData;
	Customer: ICustomer;
}
export interface IInvoiceSaveDraftResponse extends IResponseBase {
	CustomerName: string;
}

// Get invoice
export interface IGetInvoiceRequest {
  InvoiceNumber: number;
}

export interface IGetInvoiceResponse extends IResponseBase {
  Invoice: IInvoiceData;
  LineItems: ILineItem[];
  SourceItems: ILineItem[];
}

// Submit invoice
export interface ISubmitInvoiceResponse extends IResponseBase {}

// Void invoice
export interface IVoidInvoiceResponse extends IResponseBase {}


// Send invoice
export interface INotifyInvoiceRequest  {
	InvoiceNumber: string | undefined;
	Recipients: string[];
	MessageForCustomer: string;
	IsSubmittingLater?: boolean;
}

// Send invoice
export interface INotifyInvoiceResponse extends IResponseBase {}


export class PostToQuickbooksRequest  {
	public InvoiceNumber: string ='';
	public InvoiceNumbers: string[];
}

export class PostToQuickbooksResponse extends ResponseBase {}

export class ResetInvoiceStatusRequest  {
	public InvoiceNumber: string ='';
	public Status: InvoiceStatus;
}

export class ResetInvoiceStatusResponse extends ResponseBase {}



// export class InvoiceFilter
// {
// 	public Drafts: boolean;
// 	public Voided: boolean;
// 	public Posted: boolean;
// }


export enum InvoiceStatus
{
	Any = 10,
	ReadyToPost = 20,
	Posted = 30,
	Draft = 40,
	Voided = 50,
}

